module.exports = __webpack_public_path__ + "img/services-hero.e74e69e5.jpg";